import ActionBarItem from '@rio-cloud/rio-uikit/ActionBarItem';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { ADMINISTRATION_ROUTE } from '../../routes/Router';
import { chapters, type ServiceInfoChapter } from './chapters';
import { serviceInfoDialogOpenedAtChapter } from './serviceInfoSlice';
import { useOnboarding } from '../../hooks/useOnboarding';
import { useServiceInfoSearchParams } from './serviceInfoSearchParams';

export const ServiceInfoPopover = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { showServiceInfo } = useServiceInfoSearchParams();

    const { run } = useOnboarding();

    const handleOpenChapter = (chapter: string) => {
        const serviceInfoChapter = chapter as ServiceInfoChapter;

        dispatch(serviceInfoDialogOpenedAtChapter(serviceInfoChapter));
        showServiceInfo(serviceInfoChapter);
    };

    const onShowOnboardingTour = () => {
        navigate(ADMINISTRATION_ROUTE);
        run();
    };

    return (
        <ActionBarItem.List>
            <ActionBarItem.ListItem icon='rioglyph-hand-right' onClick={() => handleOpenChapter(chapters.welcome)}>
                <FormattedMessage id='intl-msg:rental-web.serviceinfo.welcome' />
            </ActionBarItem.ListItem>
            <ActionBarItem.ListItem icon='rioglyph-question-sign' onClick={() => handleOpenChapter(chapters.whatsNew)}>
                <FormattedMessage id='intl-msg:rental-web.serviceinfo.whatsNew' />
            </ActionBarItem.ListItem>
            <ActionBarItem.ListItem icon='rioglyph-envelope' onClick={() => handleOpenChapter(chapters.feedback)}>
                <FormattedMessage id='intl-msg:rental-web.serviceinfo.feedback' />
            </ActionBarItem.ListItem>
            <ActionBarItem.ListSeparator />
            <ActionBarItem.ListItem icon='rioglyph-onboarding' onClick={onShowOnboardingTour}>
                <FormattedMessage id='intl-msg:rental-web.service-info.show-onboarding-tour' />
            </ActionBarItem.ListItem>
        </ActionBarItem.List>
    );
};
